import http from './request'

// 创建活动记录接口
export const userSmsStatCreate = (data) => {
  return http({
    url: '/promotion/UserSmsStat/create',
    method: 'post',
    data
  })
}

export const userSmsGetTaskRewards = (data) => {
  return http({
    url: '/promotion/UserSmsStat/getTaskRewardList',
    method: 'post',
    data
  })
}
//分页查询用户短信统计信息
export const userSmsGetPagedList = (data) => {
  return http({
    url: '/promotion/UserSmsStat/getPagedList',
    method: 'post',
    data
  })
}
//抽奖接口
export const userSmsdoUserLottery = (data) => {
  return http({
    url: '/promotion/Lottery/doUserLottery',
    method: 'post',
    data
  })
}
//周期活动-获取抽奖机会
export const userGetLotteryChance = (data) => {
  return http({
    url: '/promotion/Lottery/getChance',
    method: 'post',
    data
  })
}

//推送IM消息接口 REMIND
export const userSmsStatSendMsg = (data) => {
  return http({
    url: '/promotion/UserSmsStat/sendRemainMsg',
    method: 'post',
    data
  })
}


//短信营销活动-获取任务列表
export const getActivitySMSListTask = (data) => {
  return http({
    url: '/promotion/ActivitySmsTask/listTask',
    method: 'post',
    data
  })
}
//短信营销活动-领取任务
export const activityAcceptTask = (data) => {
  return http({
    url: '/promotion/ActivitySmsTask/acceptTask',
    method: 'post',
    data
  })
}
//短信营销活动-领取任务奖励
export const activityReciveReward = (data) => {
  return http({
    url: '/promotion/ActivitySmsTask/receiveReward',
    method: 'post',
    data
  })
}
//领取下级完成任务奖励
export const userSmsStatReciveReward = (data) => {
  return http({
    url: '/promotion/UserSmsStat/receiveReward',
    method: 'post',
    data
  })
}